import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SimpleModalWithHeader from './simple_modal_with_header.jsx';
import Button from './btn_basic.jsx';

class FormSimpleModal extends Component {

  render() {

    const { title, confirmText, confirmDisabled, cancelText, onCancel, onConfirm, children, ...rest } = this.props;

    return (
      <SimpleModalWithHeader
        title={title} 
        show={this.props.show} 
        onRequestClose={this.props.onCancel}
        closeOnOuterClick={this.props.closeOnOuterClick}
        {...rest}>

        <div>
          {children}
        </div>

        <div style={{textAlign:'right', marginTop:'25px'}}>
          <Button type="secondary"  onClick={onCancel}>
            {cancelText}
          </Button>

          <Button style={{marginLeft:'10px'}} 
            onClick={onConfirm} disabled={confirmDisabled}>
              {confirmText}
          </Button>

          <div className="clear"></div>
        </div>

      </SimpleModalWithHeader>
    );
  }
}


FormSimpleModal.propTypes = {
  title: PropTypes.string.isRequired,
  confirmText: PropTypes.node,
  confirmDisabled: PropTypes.bool,
  cancelText: PropTypes.string,

  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,

  show: PropTypes.bool
};

FormSimpleModal.defaultProps = {
  confirmText: 'Submit',
  confirmDisabled: false,
  cancelText: 'Cancel',
  show: true
};


export default FormSimpleModal;
